export const Status = {
  0: {titulo: 'Aberto', class: 'warning', color: '#ff9814'},
  1: {titulo: 'Entregue', class: 'success', color: '#2ecc71'}
}

export const StatusTitle = function (s, t) {
  t = typeof t !== 'undefined' ? t : 'titulo'
  if (typeof Status[s] === 'undefined') {
    return 'Unknow status code'
  }
  return Status[s][t]
}

export const STATUS_ABERTO = 0
export const STATUS_ENTREGUE = 1



// WEBPACK FOOTER //
// ./src/domain/callcenter/helpers/SolicitacaoStatus.js